import React, { useEffect, useLayoutEffect, useRef, useState } from "react";
import AppEditor from "../AppEditor/AppEditor";
import ImagePlaceHolder from "../ImagePlaceHolder/ImagePlaceHolder";
import "./PageEditor.css";
import LeftToolbar from "./LeftToolbar";
import RightToolbar from "./RightToolbar";
import { withRouter } from "../../app-services/lib/router-compat";
import { PageFooter, PageScroller } from "./PageFooter";
import SubscriptionPlan from "../payment/checkout/SubscriptionPlan";

mixins.addScript("https://html2canvas.hertzen.com/dist/html2canvas.min.js");
mixins.addScript("https://unpkg.com/jspdf@latest/dist/jspdf.umd.min.js");

export function PageEditor(props) {
  const self = useRef({}).current;
  const refsBag = useRef({});
  const pageContents = useRef({});
  const inputValue = useRef("");
  const scrlpagetiles = useRef(null);
  const pagetileref = useRef(null);
  const pageref = useRef(null);
  const prevPropsRef = useRef(props);

  const [inputValueState, setInputValueState] = useState("");
  const [outerPageStyle] = useState({
    background: "whitesmoke",
    padding: "4px",
    display: "flex",
    minWidth: "max-content",
    margin: "auto",
  });
  const [currentIndex, setCurrentIndex] = useState(0);
  const [dragedPage, setDragedPage] = useState(null);
  const [overlayStyle] = useState({});
  const [pageStyle] = useState({
    minHeight: "197mm",
    height: "197mm",
    width: "130mm",
    maxWidth: "130mm",
    paddingTop: "20mm",
    paddingBottom: "25mm",
    margin: "auto",
    overflow: "hidden",
    backgroundRepeat: "no-repeat",
    backgroundColor: "#ffffff",
    boxSizing: "border-box",
    textAlign: "left",
    ...(props.pageStyle || {}),
  });
  const [pages, setPages] = useState(props.pagePayload || []);

  const state = {
    inputValue: inputValueState,
    outerPageStyle,
    currentIndex,
    scrlpagetiles,
    pagetileref,
    pageref,
    dragedPage,
    overlayStyle,
    pageStyle,
    pages,
  };

  self.props = props;

  useLayoutEffect(() => {
    initialConstruct.bind(self)("PageEditor", props);
    self.refs = refsBag.current;
    self.pageContents = pageContents.current;
  }, []);

  self.state = state;
  self.refs = refsBag.current;
  self.pageContents = pageContents.current;
  self.history = props.history || window.reduxHistory;

  self.setState = (update, callback) => {
    const applyUpdate = (prev) => {
      const next = typeof update === "function" ? update(prev, props) : update;
      if (next.currentIndex !== undefined) setCurrentIndex(next.currentIndex);
      if (next.dragedPage !== undefined) setDragedPage(next.dragedPage);
      if (next.pages !== undefined) setPages(next.pages);
      if (next.inputValue !== undefined) setInputValueState(next.inputValue);
      return next;
    };
    if (typeof update === "function") {
      applyUpdate(state);
    } else {
      applyUpdate({ ...state, ...update });
    }
    if (callback) setTimeout(callback, 0);
  };

  const generatePDF = () => {
    let modal = loader("Generating PDF please wait");
    setTimeout(() => {
      getPayload(true).then((pagesVal) => {
        let doc = new jspdf.jsPDF({
          html2canvas: {
            useCORS: true,
            allowTaint: true,
          },
        });
        Object.values(pagesVal).map((obj, i) => {
          let height = (197 * 2).toPx();
          let width = (130 * 2).toPx();
          if (i > 0) {
            doc.addPage(width, height);
          }
          doc.setPage(i + 1);
          doc.addImage(
            obj.base64,
            "PNG",
            0,
            0,
            width,
            height,
            "alias" + i,
            "SLOW"
          );
        });
        doc.save("book.pdf");
        modal.close();
        alert("Thank you for generating the book, please visit again");
        self.history.push("/");
      });
    });
  };

  const updatePageContents = () => {
    const MAX_CONTENT_SIZE = 500;
    let { pagePayload, charcount = MAX_CONTENT_SIZE } = props;
    let payload = Object.map(refsBag.current, (val, key) => {
      return val.current && val.current.outerHTML;
    });
    pageContents.current = Object.assign(pageContents.current, payload);
    Object.map(pageContents.current, (html, key) => {
      let editor = (html || "")
        .toHTML()
        .querySelector("#editor-container")
        ?.toText();
      let pageEle = document.querySelector("#charcount-" + key);
      if (pageEle) {
        let count = pageEle.querySelector("#count");
        let pageno = Number(pageEle.getAttribute("pageno") || "0");
        let page = pagePayload[pageno];
        let charcountlength = Number(page?.contentSize || charcount);
        if (count && editor) {
          if (editor?.length > charcountlength) {
            count.style.setProperty("color", "red");
          } else {
            count.style.setProperty("color", "green");
          }
          count.innerText = editor.length;
        }
      }
    });
  };

  const scrollAdjust = () => {
    setTimeout(() => {
      pagetileref.current.parentElement.scrollLeft =
        pagetileref.current.offsetLeft - 108 * 4;
    });
  };

  const previewBook = () => {
    pageref.current?.querySelector("#previewBook")?.click();
  };

  const changePage = (dir) => {
    let { pagePayload, nextmode = false } = props;
    let step = 1;
    if (
      nextmode &&
      currentIndex % 2 == 0 &&
      currentIndex + (dir == "next" ? 2 : -2) < pagePayload.length
    ) {
      step = 2;
    }
    switch (dir) {
      case "prev":
        if (currentIndex <= 0) {
          return;
        }
        setCurrentIndex(currentIndex - step);
        break;
      case "next":
        if (currentIndex >= pagePayload.length - 1) {
          previewBook();
          return;
        }
        setCurrentIndex(currentIndex + step);
        break;
    }
    scrollAdjust();
  };

  const handelPast = (e) => {
    let { pagePayload } = props;
    let getNode = (i) =>
      refsBag.current[pages[i].name].current.querySelector("#editor-container");
    e.stopPropagation();
    e.preventDefault();
    let localpages = pages;
    let rightpages = pagePayload.slice(currentIndex);
    let clipboardData = e.clipboardData || window.clipboardData;
    let pastedData = clipboardData.getData("Text");
    rightpages
      .filter((o) => o.pagetype != "fullimage")
      .map((page, i) => {
        let localpage = localpages.find((o) => o.name == page.name) || page;
        let filldata = pastedData.slice(
          0,
          localpage.contentSize || props.charcount
        );
        let node = getNode(currentIndex + i);
        if (i === 0) {
          node.innerText += filldata;
        } else {
          node.innerText = filldata;
        }

        pastedData = pastedData.slice(localpage.contentSize || props.charcount);
      });
  };

  const getPageStyle = (i, splitMode = false) => {
    let { pageMode = "dual", bookMode = true } = props;
    let isCurrentEven = () => currentIndex % 2 == 0 || currentIndex == 0;
    let objStyle = '';
    if(props.match.params.name == "customcharacter-book"){
      objStyle =
      i % 2 == 0 || i == 0
        ? {
            marginLeft:
              pageMode == "dual" && bookMode && currentIndex != 0
                ? !isCurrentEven()
                  ? "auto"
                  : "0px"
                : "auto",
            marginRight:
              pageMode == "dual" && bookMode && currentIndex != 0
                ? !isCurrentEven()
                  ? "0px"
                  : "auto"
                : "auto",
          }
        : {
            marginRight:
              pageMode == "dual" && currentIndex != 0
                ? !isCurrentEven()
                  ? "auto"
                  : "0px"
                : "auto",
            marginLeft:
              pageMode == "dual" && bookMode && currentIndex != 0
                ? !isCurrentEven()
                  ? "0px"
                  : "auto"
                : "auto",
          };
    }else{
      objStyle =
      i % 2 == 0 || i == 0
        ? {
            paddingLeft: "20mm",
            paddingRight: "15mm",
            marginLeft:
              pageMode == "dual" && bookMode && currentIndex != 0
                ? !isCurrentEven()
                  ? "auto"
                  : "0px"
                : "auto",
            marginRight:
              pageMode == "dual" && bookMode && currentIndex != 0
                ? !isCurrentEven()
                  ? "0px"
                  : "auto"
                : "auto",
          }
        : {
            paddingLeft: "15mm",
            paddingRight: "20mm",
            marginRight:
              pageMode == "dual" && currentIndex != 0
                ? !isCurrentEven()
                  ? "auto"
                  : "0px"
                : "auto",
            marginLeft:
              pageMode == "dual" && bookMode && currentIndex != 0
                ? !isCurrentEven()
                  ? "0px"
                  : "auto"
                : "auto",
          };
    }
    return {
      ...objStyle,
      ...(splitMode
        ? {
            backgroundSize: "200% 100%",
            backgroundPosition: i % 2 == 0 || i == 0 ? "right" : "left",
          }
        : {
            backgroundSize: "100% 100%",
            backgroundPosition: "center",
          }),
    };
  };

  const getContent = (page) => {
    let content = pageContents.current[page.name] || page.content;
    return content;
  };

  const getOverlayStyle = (i, page) => {
    let overlayData = mixins
      .getDataNode(getContent(page))
      .querySelector("#overlay-data");
    let overlayStyleVal = {};
    if (overlayData) {
      overlayStyleVal = overlayData.style.getStyle();
    }
    return {
      position: "absolute",
      left: 0,
      top: 0,
      width: "inherit",
      height: "inherit",
      zIndex: 1,
      ...overlayStyleVal,
    };
  };

  const getPage = (pageObj, i) => {
    let {
      readonly,
      pageMode = "dual",
      match: {
        params: { genpdf },
      },
      pageBordered = true,
      uploadplaceholder = undefined,
    } = props;
    if (!readonly && genpdf) {
      readonly = true;
    }
    let localPage = pages[i];
    let page = { ...localPage, ...pageObj, pagetype: localPage.pagetype };
    let { fullTextStyle, fullImageStyle, imageTextStyle, outerStyle } = {
      fullTextStyle: { height: "100%", background: "#ffffffe3" },
      fullImageStyle: { height: "100%", background: "transparent" },
      imageTextStyle: {
        display: "flex",
        flexDirection: "column",
        height: "100%",
      },
      outerStyle: {
        display: "flex",
        flexDirection: "column",
        height: "100%",
        boxSizing: "border-box",
      },
    };

    let backgroundObj = localPage.backgroundObj || {};
    let splitMode = backgroundObj.splitMode || false;
    let finalcontent = getContent(page);
    page.content = finalcontent;
    let pageEle = mixins.getDataNode(finalcontent).querySelector(".book-page");
    let contentStyle = pageEle?.style.getStyle() || { ...pageStyle };
    let acceptedKeys = ["background", "backgroundImage", "backgroundColor"];
    contentStyle = Object.filter(
      contentStyle,
      (v, k) => acceptedKeys.includes(k) || !k.includes("background")
    );
    let viewonly = pageMode == "dual" && i == currentIndex - 1;
    page.isLastPage = pageEle?.classList.contains("last-page") || false;
    if (pageEle) {
      splitMode =
        splitMode || (pageEle.getAttribute("splitmode") || "false").parse();
      let localPageStyle = getPageStyle(i, splitMode);
      contentStyle = {
        ...contentStyle,
        ...localPageStyle,
        ...backgroundObj,
      };
    } else {
      let localPageStyle = getPageStyle(i, splitMode);
      contentStyle = {
        ...contentStyle,
        ...localPageStyle,
        ...backgroundObj,
      };
    }

    let component = () => <div></div>;
    let attributes = {};
    refsBag.current = {
      ...refsBag.current,
      [page.name]: React.createRef(),
    };
    let getReadOnly = () => viewonly || page.readonly || readonly;
    switch (page.pagetype) {
      case "fulltext":
        component = (compProps) => (
          <div
            style={outerStyle}
            className={Object.className({
              pageborder: pageBordered,
            })}
            tabIndex={0}
          >
            <AppEditor
              style={fullTextStyle}
              data={page}
              hasToolBar={!(page.readonly || readonly)}
              pageref={refsBag.current[page.name]}
              readonly={getReadOnly()}
            ></AppEditor>
          </div>
        );
        break;
      case "fullimage":
        component = (compProps) => (
          <div
            style={outerStyle}
            className={Object.className({
              pageborder: pageBordered,
            })}
            tabIndex={0}
          >
            <ImagePlaceHolder
              style={fullImageStyle}
              data={page}
              pageref={refsBag.current[page.name]}
              readonly={getReadOnly()}
              onUpdate={() => updatePageContents()}
              uploadplaceholder={uploadplaceholder}
            ></ImagePlaceHolder>
          </div>
        );
        break;
      case "halftexthalfimage":
        component = (compProps) => (
          <div
            style={imageTextStyle}
            className={Object.className({
              pageborder: pageBordered,
            })}
            tabIndex={0}
          >
            <ImagePlaceHolder
              style={{ height: "50%", background: "transparent" }}
              data={page}
              pageref={refsBag.current[page.name]}
              readonly={getReadOnly()}
              onUpdate={() => updatePageContents()}
              uploadplaceholder={uploadplaceholder}
            ></ImagePlaceHolder>
            <AppEditor
              style={{ height: "50%", background: "#ffffffe3" }}
              data={page}
              hasToolBar={!getReadOnly()}
              pageref={refsBag.current[page.name]}
              readonly={viewonly || page.readonly || readonly}
            ></AppEditor>
          </div>
        );
        break;
    }

    return [
      component,
      attributes,
      refsBag.current[page.name],
      contentStyle,
      splitMode,
      page,
    ];
  };

  const getPages = () => {
    return props.pagePayload.map((v, i) => getPage(v, i));
  };

  const updatePagesStyles = () => {
    const changeHandler = (event) => {
      inputValue.current = event.target.value;
    };
    let dialog = confirm(
      () => (
        <div className="Background">
          <div className="row align-items-center">
            <div className="col-12">
              <div className="inner-border">
                <div>
                  <input
                    onChange={(e) => changeHandler(e)}
                    placeholder="No. of Pages"
                    onKeyPress={(event) => {
                      if (!/[0-9]/.test(event.key)) {
                        event.preventDefault();
                      }
                    }}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      ),
      "Set Template",
      {
        ok: "Apply",
        class: "setpagestyle",
        parentclass: "SelfPublish",
      }
    );
    return new Promise((resolve, reject) => {
      dialog.promise.then(() => {
        emit.trigger('openloader',`Please wait...`);
        let pageLenght = props.lastPageNo;
        if (inputValue.current > pageLenght - 5) {
          alert(`Please enter within ${pageLenght - 5} pages.`);
          emit.trigger('closeloader');
        } else {
          setTimeout(()=>{
            resolve(inputValue.current);
          },0);
        }
      });
    });
  };

  const setCurrentPage = (page) => {
    if (page) {
      updatePagesStyles().then((rangeCount) => {
        for (let i = 0; i < rangeCount; i++) {
          let oldpage = pages[currentIndex + i];
          pages[currentIndex + i].pagetype = page.pagetype;

          switch (page.pagetype) {
            case "fulltext":
              pages[currentIndex + i].contentSize = 1000;
              break;
            case "halftexthalfimage":
              pages[currentIndex + i].contentSize = 500;
              break;
          }

          let liveeditor = (selector = "#editor-container") =>
            refsBag.current[oldpage.name].current.querySelector(selector) || {
              style: {},
            };
          if (page.content && refsBag.current[oldpage.name]) {
            let saveeditor = (selector = "#editor-container") =>
              mixins.getDataNode(page.content).querySelector(selector) || {
                style: {},
              };
            if (liveeditor && saveeditor) {
              let savedStyle = saveeditor(".book-page").style.getStyle();
              let oldStyle = pages[currentIndex + i].backgroundObj || {};
              pages[currentIndex + i].backgroundObj = {
                ...oldStyle,
                ...Object.filter(savedStyle, (v, k) =>
                  ["background", "fontFamily"].includes(k)
                ),
              };
              pageContents.current[oldpage.name] = saveeditor.innerHTML;
              setTimeout(() => {
                liveeditor().innerHTML = saveeditor().innerHTML;
                liveeditor(".TextResizeConatiner").style.height =
                  saveeditor(".TextResizeConatiner").style.height || "100%";
              });
              setPages([...pages]);
            }
          } else {
            setTimeout(() => {
              switch (page.pagetype) {
                case "fulltext":
                  liveeditor(".TextResizeConatiner").style.height = "100%";
                  break;
              }
            });
            setPages([...pages]);
          }
        }
        emit.trigger('closeloader');
      });
    }
  };

  const setPage = (index) => {
    setCurrentIndex(index);
    scrollAdjust();
  };

  const setDragedPageHandler = (obj) => {
    setDragedPage(obj);
  };

  const saveBook = () => {
    return new Promise((resolve, reject) => {
      let { onSave = () => ({}), png = false } = props;
      let modal = loader("Generating the pages please wait ...");
      let subscribeUsFlag = false;

      if (!props.bookDetails.id) {
        subscribeUsFlag = api.checkSubscribeUser(self);
      }
      if (subscribeUsFlag) {
        modal.close();
        if(subscribeUsFlag!=messages.save_book_limitation_warning_subscribed_user) {
          alert(
            (alertProps) => (
              <SubscriptionPlan
                alert={alertProps}
                id={props.bookDetails.id}
                key={props.bookDetails.id}
              />
            ),
            "",
            "model",
            {
              footer: false,
              class: "personalize-col col-8 col-md-8 col-lg-6 col-xl-6",
              options: {},
            }
          );
        }
        alert(subscribeUsFlag);
      } else {
        setTimeout(() => {
          getPayload(png).then((...arg) => {
            modal.close();
            onSave(...arg)
              .then((...saveArg) => {
                mixins.reFectchSavedBookDetails(props)
                .then(()=>resolve(...saveArg))
                .catch(()=>resolve(...saveArg));
              })
              .catch(reject);
          });
        });
      }
    });
  };

  const getPayload = (png = false) => {
    if (png) {
      return new Promise((resolve, reject) => {
        Object.mapPromise(
          refsBag.current,
          (o) =>
            new Promise((r, rj) => {
              o.current
                .toDataURL()
                .then((pngVal) => r({ html: o.current.outerHTML, png: pngVal }))
                .catch(rj);
            })
        )
          .then((htmls) => {
            let payload = Object.map(htmls, (obj) => ({
              html: obj.html,
              base64: obj.png,
            }));
            resolve(payload);
          })
          .catch(reject);
      });
    } else {
      return new Promise((resolve, reject) => {
        resolve(
          Object.map(refsBag.current, (val, key) => {
            return {
              html: val?.current?.outerHTML,
              png: "",
              base64: "",
            };
          })
        );
      });
    }
  };

  const applyBackground = (backgroundObj) => {
    let oldstyle = pages[currentIndex].backgroundObj;
    pages[currentIndex].backgroundObj = {
      ...oldstyle,
      ...backgroundObj,
    };
    setPages([...pages]);
  };

  self.generatePDF = generatePDF;
  self.updatePageContents = updatePageContents;
  self.scrollAdjust = scrollAdjust;
  self.changePage = changePage;
  self.handelPast = handelPast;
  self.getPageStyle = getPageStyle;
  self.getPages = getPages;
  self.getPage = getPage;
  self.getContent = getContent;
  self.getOverlayStyle = getOverlayStyle;
  self.updatePagesStyles = updatePagesStyles;
  self.setCurrentPage = setCurrentPage;
  self.setPage = setPage;
  self.setDragedPage = setDragedPageHandler;
  self.saveBook = saveBook;
  self.previewBook = previewBook;
  self.getPayload = getPayload;
  self.applyBackground = applyBackground;

  useEffect(() => {
    const mountRef = pageref.current;
    if (!mountRef) return;
    mountRef.onkeydown = mountRef.onmousedown = () => {
      clearTimeout(mountRef.sti || 0);
      mountRef.sti = setTimeout(() => {
        updatePageContents();
      }, 500);
    };
  }, []);

  // Keep local pages in sync with parent pagePayload (class PageEditor used props for render;
  // state.pages is still passed to RightToolbar / preview)
  useEffect(() => {
    if (Array.isArray(props.pagePayload)) {
      setPages(props.pagePayload);
    }
  }, [props.pagePayload]);

  useEffect(() => {
    self.watch(
      {
        bookDetails() {},
        pagePayload(val) {
          let {
            match: {
              params: { genpdf },
            },
          } = props;
          genpdf = Number(genpdf);
          let payload = val.reduce(
            (o, n) => ({ ...o, [n.name]: n.content }),
            {}
          );
          pageContents.current = Object.assign(pageContents.current, payload);
          if (genpdf) {
            mixins.debounce(
              {},
              () => {
                generatePDF();
              },
              "pagePayload"
            );
          }
        },
      },
      props,
      prevPropsRef.current
    );
    prevPropsRef.current = props;
  });

  let {
    match: {
      params: { genpdf },
    },
    message = "",
    showCount = true,
    pagePayload = [],
    bookDetails = {},
    pageMode = "dual",
    overlay = false,
    leftTool = !Number(genpdf),
    has = [],
    editbackground = true,
    pageBordered = true,
    paginate = true,
    onUpdate = () => "",
    closablePreview = true
  } = props;
  genpdf = Number(genpdf);

  return (
    <div
      className="PageEditor"
      onPaste={(e) => handelPast(e)}
      ref={pageref}
      tabIndex={0}
    >
      <div className="container-fluid">
        <div className="row no-gutters">
          <div className="col-12 col-lg-1 left-toolbar">
            {leftTool && (
              <LeftToolbar
                has={has}
                setDragedPage={(...arg) => setDragedPageHandler(...arg)}
                setCurrentPage={(...arg) => setCurrentPage(...arg)}
              />
            )}
          </div>
          <div
            className="col-12 col-lg-10"
            onDrop={() => setCurrentPage(dragedPage)}
            onDragOver={(ev) => ev.preventDefault()}
            style={{ overflowX: "auto", maxWidth: "100vw" }}
          >
            <div style={outerPageStyle}>
              {getPages()
                .map(([Page, attrs, ref, style, splitMode, page], i) => (
                  <div
                    ref={ref}
                    key={i}
                    style={{ ...pageStyle, ...style, ...(page.style || {}) }}
                    className={
                      "book-page " +
                      Object.className({
                        active: i == currentIndex,
                        viewonly: pageMode == "dual" && i == currentIndex - 1,
                        pageBordered,
                        "last-page": page.isLastPage,
                      })
                    }
                    splitmode={(!!splitMode).toString()}
                  >
                    {overlay && (
                      <div
                        id="overlay-data"
                        style={{ ...getOverlayStyle(i, page) }}
                      ></div>
                    )}
                    {showCount && (
                      <div
                        id={"charcount-" + page.name}
                        className="charcount"
                        pageno={i}
                        style={{
                          display: "none",
                          position: "absolute",
                          top: "50px",
                          left: "10px",
                          backgroundColor: "rgba(221, 221, 212, 0.56)",
                          padding: "10px",
                          border: "4px",
                          boxShadow: "1px 1px 1px 0px",
                        }}
                      >
                        <b>Content Count</b>
                        <span
                          id="count"
                          style={{
                            padding: "5px",
                            fontWeight: "bold",
                            fontStyle: "italic",
                          }}
                        ></span>
                      </div>
                    )}
                    <Page {...attrs}></Page>
                  </div>
                ))}
            </div>
          </div>
          <div className="col-12 col-lg-1 right-toolbar">
            <RightToolbar
              saveBook={(...arg) => saveBook(...arg)}
              onPreview={(...arg) => previewBook(...arg)}
              currentIndex={currentIndex}
              pages={pages.map((o) => ({
                ...o,
                backgroundObj: o.backgroundObj || {},
              }))}
              getPayload={() => getPayload()}
              applyBackground={(...arg) => applyBackground(...arg)}
              hasBtns={{
                editbackground: editbackground && !genpdf,
                needsave: !genpdf,
                needpreview: !genpdf,
              }}
              bookDetails={bookDetails}
              message={message}
              onUpdate={onUpdate}
              closablePreview={closablePreview}
              params={props.match.params}
              onPreviewClose={props.onPreviewClose}
            >
              {props.RightChildren || (() => "")}
            </RightToolbar>
          </div>
        </div>
        {message && (
          <div className="row">
            <div className="col-1"></div>
            <div
              className="col text-center"
              style={{ fontWeight: "bold", color: "red" }}
              dangerouslySetInnerHTML={{ __html: message }}
            ></div>
            <div className="col-1"></div>
          </div>
        )}
        <PageFooter
          currentIndex={currentIndex}
          pagePayload={pagePayload}
          changePage={(...arg) => changePage(...arg)}
        />
      </div>
      {paginate && (
        <div className="container bottom_scroller">
          <PageScroller
            currentIndex={currentIndex}
            pagePayload={pagePayload}
            setPage={(...arg) => setPage(...arg)}
            scrlpagetiles={scrlpagetiles}
            pagetileref={pagetileref}
          />
        </div>
      )}
    </div>
  );
}

export default connect(withRouter(PageEditor));
